import { EntryApiAdapter } from '../../adapters';
import { Entry, EntryApiResponse, EntryFilters } from '../../models';

export class EntryService {
  constructor(private adapter: EntryApiAdapter) {}

  async getPaginated(filters: EntryFilters = {}) {
    const response = await this.adapter.getEntries({
      ...filters,
      per_page: filters.per_page || 15,
      sorting: filters.sorting || {
        column: 'id',
        direction: 'desc',
      },
    });

    const entries: Entry[] = response.data || [];
    const meta: EntryApiResponse['meta'] = response.meta ?? {};
    // La API puede devolver snake_case o camelCase (como en CRM / merchandise)
    const currentPage = meta.current_page ?? meta.currentPage ?? 1;
    const lastPage = meta.last_page ?? meta.lastPage ?? 1;
    const total = meta.total ?? 0;

    return {
      entries,
      total,
      currentPage,
      lastPage,
      // undefined → TanStack Query marca hasNextPage: false (null puede comportarse distinto)
      nextPage:
        currentPage < lastPage ? currentPage + 1 : undefined,
    };
  }
}

